import { useState } from "react";
import { getFilterDisplayName } from "../../utils/getFilterDisplayName";
import { Show, Checkbox } from "shared/components";
import { BaseInput, InputSize } from "shared/components/forms/BaseInput";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  ArrowUp01Icon,
  ArrowDown01Icon
} from "@hugeicons-pro/core-solid-rounded";

const filterOptionsBySearch = (
  options: { id?: string; name: string; count: number }[],
  search: string
) => {
  return options.filter((option) =>
    option.name.toLowerCase().includes(search.toLowerCase())
  );
};

export const FilterSection = ({
  title,
  options,
  optionLimit,
  selectedOptions,
  onChange
}: {
  title: string;
  options: { id?: string; name: string; count: number }[];
  optionLimit?: number;
  selectedOptions: string[];
  onChange: (name: string) => void;
}) => {
  const [expanded, setExpanded] = useState(true);
  const [showAll, setShowAll] = useState(false);
  const [search, setSearch] = useState("");

  const displayedOptions = showAll
    ? filterOptionsBySearch(options, search)
    : filterOptionsBySearch(options, search).slice(0, optionLimit);

  const shouldShowMoreButton =
    optionLimit &&
    displayedOptions.length >= optionLimit &&
    options.length > optionLimit;

  return (
    <div className="py-4">
      <button
        className=" w-full flex items-center justify-between cursor-pointer"
        onClick={() => setExpanded((prev) => !prev)}
      >
        <p className="text-content-1000 text-sm font-bold">{title}</p>

        <HugeiconsIcon icon={expanded ? ArrowUp01Icon : ArrowDown01Icon} />
      </button>

      <Show if={expanded}>
        <div className="mt-4">
          <Show if={!title.toLowerCase().includes("status")}>
            <BaseInput
              id="search"
              autoComplete="off"
              placeholder="Search..."
              value={search}
              onChange={(value) => setSearch(value)}
              size={InputSize.SM}
              className="h-12 mb-4"
            />
          </Show>

          <Show if={!displayedOptions.length}>
            <p className="text-sm text-content-400">No options available</p>
          </Show>

          <div
            className="space-y-2"
            style={{
              maskImage:
                shouldShowMoreButton && !showAll
                  ? "linear-gradient(to bottom, rgba(0, 0, 0, 1.0) 0%, transparent 100%)"
                  : "none"
            }}
          >
            {displayedOptions.map((option) => (
              <Checkbox
                key={option.id ?? option.name}
                id={option.id ?? option.name}
                name={option.id ?? option.name}
                checked={selectedOptions.includes(
                  option.id != null ? String(option.id) : option.name
                )}
                label={`${getFilterDisplayName(option.name)} (${option.count})`}
                labelClassName="whitespace-normal"
                onChange={() => onChange(option.id ?? option.name)}
              />
            ))}
          </div>
          <Show if={shouldShowMoreButton}>
            <button
              className="text-primary-500 text-sm mt-2 font-bold"
              onClick={() => setShowAll((prev) => !prev)}
            >
              {showAll ? "Show less" : "Show more"}
            </button>
          </Show>
        </div>
      </Show>
    </div>
  );
};
